import * as Yup from 'yup';

export const SendTestEmailFormValidationSchema = Yup.object().shape({
  email: Yup.string()
    .nullable()
    .email('Email address is incorrect')
    .required('This field is required')
    .max(100, 'You have exceeded the maximum number of 100 characters'),
});
